import { css, keyframes } from 'styled-components';
import { alpha, ANIMATION_CURVE, ANIMATION_DURATION, getToken } from '@optimus-web/common';

const shimmer = keyframes`
    0% {
        transform: translateX(-100%);
    }
    50% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(100%);
    }
`;

export const commonSkeletonStyles = css`
    background-color: ${(props) =>
        alpha(getToken('backgroundInteractiveNeutralBoldDefault')(props), getToken('opacity150')(props))};
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            90deg,
            ${(props) => alpha(getToken('backgroundStaticFlat')(props), 0)},
            ${(props) => alpha(getToken('backgroundStaticFlat')(props), getToken('opacity800')(props))},
            ${(props) => alpha(getToken('backgroundStaticFlat')(props), 0)}
        );
        animation: ${shimmer} ${ANIMATION_DURATION.duration90}ms ${ANIMATION_CURVE.easeInOut} infinite;
    }
`;
